__turbopack_context__.v({
  "buttons": "styles-module-scss-module__0zhUBq__buttons",
  "underlineButton": "styles-module-scss-module__0zhUBq__underlineButton",
});
